export const shouldRenderDemoDashboard = (): boolean => {
  return (
    window !== undefined &&
    (window.location.hostname === 'dashboard-demo.algoan.com' ||
      window.location.hostname === 'dashboard-demo.preprod.algoan.com' ||
      window.location.hostname === 'dashboard-demo.dev.algoan.net')
  );
};
